export default ({ request }) => ({
  materialAbnormalListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/list',
      method: 'post',
      data,
    })
  },
  materialAbnormalSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/save',
      method: 'post',
      data,
    })
  },
  materialAbnormalDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/detail',
      method: 'post',
      data,
    })
  },
  materialAbnormalDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/del',
      method: 'post',
      data,
    })
  },
  materialAbnormalRejectedApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/force/reject',
      method: 'post',
      data,
    })
  },
  materialAbnormalSubmitAuditApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/submit',
      method: 'post',
      data,
    })
  },
  materialAbnormalSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/user/material/abnormal/apply',
      method: 'post',
      data,
    })
  },
  materialAbnormalCheckApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/check',
      method: 'post',
      data,
    })
  },
  materialAbnormalItemListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/item/list',
      method: 'post',
      data,
    })
  },
  materialAbnormalDocistApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/doc/list',
      method: 'post',
      data,
    })
  },
  materialAbnormalBusinessProcessingApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/business/processing',
      method: 'post',
      data,
    })
  },
  materialAbnormalCopyApi(data = {}) {
    return request({
      url: '/digitalCenter/user/material/abnormal/copy',
      method: 'post',
      data,
    })
  },
})
